module.exports = __webpack_public_path__ + "static/media/person.0ca2468b.svg";